/**
 * Created by karlaelliott on 2/10/15.
 */
dealershipModule.factory('dealershipService',
    ['$q', 'AppSettings', 'userAuthenticateService', 'commonRESTCallService', 'commonTLCService', 'DealerInfo', 'imSessionVarsService',
        'erateSessionVarsService',
    function ($q, AppSettings, userAuthenticateService, commonRESTCallService, commonTLCService, DealerInfo, imSessionVarsService,
              erateSessionVarsService) {
        var dealershipAPI = {};
        var myURL = AppSettings.startIdentitySvcURL + 'dealerships/filters';
        var myToken = '';
        var currentDealershipName = imSessionVarsService.getCurrentDealerIMName();
        dealershipAPI.dealershipInfo = {
            name: ''
        };

        dealershipAPI.refreshDealerName = function(){
            currentDealershipName = imSessionVarsService.getCurrentDealerIMName();
            dealershipAPI.dealershipInfo.name = currentDealershipName;
        }

        if (currentDealershipName != null && currentDealershipName != 'unasigned' && currentDealershipName != '')
            dealershipAPI.dealershipInfo.name = currentDealershipName;

        //get all dealerships (paged), with filtering
        dealershipAPI.searchDealerships = function (pageNum, pageSize, sortby, sortdirection, filters) {
            var promiseWrapper = $q.defer();

            var urlGet = buildSearchUrl(pageNum, pageSize, sortby, sortdirection, filters);
            myToken = userAuthenticateService.getUserToken();

            commonRESTCallService.getFromServerWithToken(urlGet, myToken)
                .success(function(responseData, status) {
                    var dealerInfoList = responseData.ItemList.map(function(element) {
                        var dealerInfo = new DealerInfo();

                        dealerInfo.populateDataFromIdentityManagement(element, function(error, data) {
                            promiseWrapper.notify(data.name + " : " + error);
                        });
                        return dealerInfo;
                    }).filter(function(element) { return typeof element !== 'undefined'; });

                    promiseWrapper.resolve({ItemList: dealerInfoList, TotalItemCount: responseData.TotalItemCount});
                }).error(function(responseData, status) {
                    promiseWrapper.reject(responseData);
                });

            return promiseWrapper.promise;
        };

        function buildSearchUrl(pageNum, pageSize, sortby, sortdirection, filters) {
            var urlGet = myURL;

            urlGet = urlGet + '/?pagenum=' + pageNum;
            if (pageSize)
                urlGet = urlGet + '&pagesize=' + pageSize;
            if (sortby)
                urlGet = urlGet + '&sort=' + sortby + '&ordermode=' + sortdirection;
            if (filters.dealershipName)
                urlGet = urlGet + '&dealername=' + filters.dealershipName;
            if (filters.accountNumber)
                urlGet = urlGet + '&provaccountcode=' + filters.accountNumber;
            if (filters.city)
                urlGet = urlGet + '&city=' + filters.city;
            if (filters.state)
                urlGet = urlGet + '&state=' + filters.state;

            //Making sure we only get the dealerships that have access to SPAN
            urlGet = urlGet + '&legacyapplication=SPAN';

            return urlGet;
        }

        //only used to determine if user has 1 or many dealerships, so don't have 
        // to get all the user's dealerships
        dealershipAPI.getUserDealerships = function (pageNum, pageSize) {
            var promiseWrapper = $q.defer();
            //Making sure we only get the dealerships that have access to SPAN
            var urlGet = AppSettings.startIdentitySvcURL + 'dealerships/?legacyapplication=SPAN' +
                '&pagenum=' + (pageNum || '0') + '&pagesize=' + (pageSize || '9999');

            commonRESTCallService.getFromServerWithToken(urlGet, userAuthenticateService.getUserToken())
                .success(function(responseData, status) {
                    var dealerList = responseData.ItemList.map(function(element) {
                        var dealer = new DealerInfo();
                        dealer.populateDataFromIdentityManagement(element);
                        return dealer;
                    });

                    promiseWrapper.resolve(dealerList);

                }).error(function(responseData, status) {
                    promiseWrapper.reject(responseData);
                });

            return promiseWrapper.promise;
        };

        dealershipAPI.getDealership = function(id) {
            var promiseWrapper = $q.defer();

            keepTokenCurrent();

            var getDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id + "/";
            commonRESTCallService.getFromServerWithToken(getDealershipUrl, myToken)
                .success(function(responseData, status) {
                    var dealer = new DealerInfo();
                    dealer.populateDataFromIdentityManagement(responseData, function(errorMsg, dealerObj) {
                        promiseWrapper.notify(errorMsg);
                    })

                    var getSpanDealershipUrl = AppSettings.startSPANPlusSvcURL + 'spandealers/' + erateSessionVarsService.getCurrentDealerSPANId() + "/";
                    commonRESTCallService.getFromServerWithToken(getSpanDealershipUrl, myToken)
                        .success(function(responseData, status) {
                            var dealership = responseData.itemList ? responseData.itemList[0] : responseData;
                            dealer.altFinanceEnabled = !!dealership.altFinance;
                            promiseWrapper.resolve(dealer);
                        }).error(function(responseData, status) {
                                promiseWrapper.reject(responseData);
                        });
                }).error(function(responseData, status) {
                    promiseWrapper.reject(responseData);
                });

            return promiseWrapper.promise;
        };

        dealershipAPI.getDefaultDeductibles = function(providerCode) {
            // For pick lists.
            // Todo: This is actually provider specific, needs to go in a different service, not here
            // Also, will need to be customizable by provider, for now, it is for EasyCare.
            // Info does not come from DB in legacy system, it is hardwired into the page markup.
            var options = [
                { id: "000", display: "$0"},
                { id: "050", display: "$50"},
                { id: "100", display: "$100"},
                { id: "250", display: "$250"},
                { id: "500", display: "$500"}
            ];
            var deferred = $q.defer();
            deferred.resolve(options); // pre-resolve, since not async at this time
            return deferred.promise;
        };

        dealershipAPI.updateDealership = function(id, dealerInfoModel, previousDealerInfo) {
            keepTokenCurrent();

            var promises = [];

            var addressPromise = tryUpdateAddress(id, dealerInfoModel, previousDealerInfo);
            if(addressPromise)
                promises.push(addressPromise);

            var phonePromise = tryUpdatePhone(id, dealerInfoModel, previousDealerInfo);
            if(phonePromise)
                promises.push(phonePromise);

            var faxPromise = tryUpdateFax(id, dealerInfoModel, previousDealerInfo);
            if(faxPromise)
                promises.push(faxPromise);

            var namePromise = tryUpdateName(id, dealerInfoModel, previousDealerInfo);
            if(namePromise)
                promises.push(namePromise);

            var accountCodePromise = tryUpdateAccountCode(id, dealerInfoModel, previousDealerInfo);
            if(accountCodePromise)
                promises.push(accountCodePromise);

            var isActivePromise = tryUpdateIsActive(id, dealerInfoModel, previousDealerInfo);
            if(isActivePromise)
                promises.push(isActivePromise);

            var altFinancePromise = tryUpdateAltFinance(dealerInfoModel.spanId, dealerInfoModel, previousDealerInfo);
            if(altFinancePromise)
                promises.push(altFinancePromise);

            return $q.all(promises);
        };

        function keepTokenCurrent() {
            if(!myToken)
                myToken = userAuthenticateService.getUserToken();
        }

        function tryUpdateAddress(id, dealerInfoModel, previousDealerInfo) {
            var updateAddressDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id + "/addresses";

            if(dealerInfoModel.addressNeedsUpdateFrom(previousDealerInfo)) {
                var transformedData = dealerInfoModel.convertForIdentityManagement();
                var primaryAddress = transformedData.Addresses.filter(function(address){
                    return address.AddressType === 'PRIMARY';
                });

                if(primaryAddress && primaryAddress.length > 0) {
                    return commonRESTCallService.postToServerWithToken(updateAddressDealershipUrl, primaryAddress[0], myToken);
                }
            }

            return null;
        }

        function tryUpdatePhone(id, dealerInfoModel, previousDealerInfo) {
            var updatePhoneDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id + "/phones";
            if(dealerInfoModel.phoneNeedsUpdateFrom(previousDealerInfo)) {
                var transformedData = dealerInfoModel.convertForIdentityManagement();
                var primaryPhone = transformedData.Phones.filter(function(phone){
                    return phone.PhoneType === 'PRIMARY';
                });

                if(primaryPhone && primaryPhone.length > 0) {
                    return commonRESTCallService.postToServerWithToken(updatePhoneDealershipUrl, primaryPhone[0], myToken);
                }
            }

            return null;
        }

        function tryUpdateFax(id, dealerInfoModel, previousDealerInfo) {
            var updatePhoneDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id + "/phones";
            if(dealerInfoModel.faxNeedsUpdateFrom(previousDealerInfo)) {
                var transformedData = dealerInfoModel.convertForIdentityManagement();
                var faxData = transformedData.Phones.filter(function(phone){
                    return phone.PhoneType === 'FAX';
                });

                if(faxData && faxData.length > 0) {
                    return commonRESTCallService.postToServerWithToken(updatePhoneDealershipUrl, faxData[0], myToken);
                }
            }

            return null;
        }

        function tryUpdateName(id, dealerInfoModel, previousDealerInfo) {
            var updateNameDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id + "/legalname";
            if(dealerInfoModel.nameNeedsUpdateFrom(previousDealerInfo)) {
                var transformedData = dealerInfoModel.convertForIdentityManagement();

                return commonRESTCallService.postToServerWithToken(updateNameDealershipUrl, transformedData, myToken);
            }

            return null;
        }

        function tryUpdateAccountCode(id, dealerInfoModel, previousDealerInfo) {
            var updateCodeDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id + "/accountcode";
            if(dealerInfoModel.accountCodeNeedsUpdateFrom(previousDealerInfo)) {
                var transformedData = dealerInfoModel.convertForIdentityManagement();
                var providerData = transformedData.ProviderLinkIds.filter(function(link){
                    return link.ProviderId === imSessionVarsService.getCurrentProviderId();
                });

                if(providerData)
                    return commonRESTCallService.postToServerWithToken(updateCodeDealershipUrl, providerData, myToken);
            }

            return null;
        }

        function tryUpdateIsActive(id, dealerInfoModel, previousDealerInfo) {
            var updateIsActiveDealershipUrl = AppSettings.startIdentitySvcURL + 'dealerships/' + id;
            if(dealerInfoModel.isActiveNeedsUpdateFrom(previousDealerInfo)) {
                if(!dealerInfoModel.isActive) {
                    updateIsActiveDealershipUrl += '/?act=deactivate';
                }

                return commonRESTCallService.putToServerWithToken(updateIsActiveDealershipUrl, dealerInfoModel, myToken);
            }

            return null;
        }

        function tryUpdateAltFinance(spanId, dealerInfoModel, previousDealerInfo) {
            var updateAltFinanceDealershipUrl = AppSettings.startSPANPlusSvcURL + 'spandealers/' + spanId +
                '/altFinance/' + dealerInfoModel.altFinanceEnabled;
            if(dealerInfoModel.isAltFinanceNeedsUpdateFrom(previousDealerInfo)) {
                erateSessionVarsService.setDealerAltFinanceEnabled(dealerInfoModel.altFinanceEnabled);
                return commonRESTCallService.putToServerWithToken(updateAltFinanceDealershipUrl, {}, myToken);
            }

            return null;
        }

        return dealershipAPI;
    }
]);
